import axios, { AxiosResponse } from 'axios';
import { apiClient } from '../endpoints';

export interface WorkTravelZone {
    _id: string;
    name: string;
    shortName: string;
    minDistance: number;
    maxDistance: number;
    travelPrice: number;
    payrollCode: string;
    crudStatus?: number;
    createdAt?: string;
    updatedAt?: string;
}

export interface WorkTravelZonesResponse {
    data: WorkTravelZone[];
    message: string;
}

export interface WorkTravelZoneResponse {
    data: WorkTravelZone;
    message: string;
}

export interface GetAllWorkTravelZonesParams {
    active?: boolean;
    withUsage?: boolean;
}

export interface CreateWorkTravelZoneBody {
    name: string;
    shortName: string;
    minDistance: number;
    maxDistance: number;
    travelPrice: number;
    payrollCode: string;
}

export interface UpdateWorkTravelZoneBody {
    name?: string;
    shortName?: string;
    minDistance?: number;
    maxDistance?: number;
    travelPrice?: number;
    payrollCode?: string;
    crudStatus?: number;
}

export const getAllWorkTravelZones = async (queries?: GetAllWorkTravelZonesParams): Promise<WorkTravelZonesResponse> => {
    try {
        const response: AxiosResponse<WorkTravelZonesResponse> = await apiClient.get('/work-travel-zones', { params: queries });
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        }
        throw new Error('An unexpected error occurred');
    }
};

export const createWorkTravelZone = async (body: CreateWorkTravelZoneBody): Promise<WorkTravelZoneResponse> => {
    try {
        const response: AxiosResponse<WorkTravelZoneResponse> = await apiClient.post('/work-travel-zones', body);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        }
        throw new Error('An unexpected error occurred');
    }
};

export const updateWorkTravelZone = async (id: string, body: UpdateWorkTravelZoneBody): Promise<WorkTravelZoneResponse> => {
    try {
        const response: AxiosResponse<WorkTravelZoneResponse> = await apiClient.patch(`/work-travel-zones/${id}`, body);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        }
        throw new Error('An unexpected error occurred');
    }
};

export const deleteWorkTravelZone = async (id: string): Promise<WorkTravelZoneResponse> => {
    try {
        const response: AxiosResponse<WorkTravelZoneResponse> = await apiClient.delete(`/work-travel-zones/${id}`);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        }
        throw new Error('An unexpected error occurred');
    }
};
